export default __webpack_public_path__ + "static/media/comprehension_locked.da2aeab8.svg";